import { FileDownloadService } from "./FileDownloadService";
import {
    BaseService,
    CommandService,
    DatabaseImageService,
    DropDownService,
    EnvironmentService,
    ExportService,
    GlobalSearchService,
    GridDefinitionService,
    LanguageService,
    MenuService,
    NotificationService,
    PageTokenService,
    PeoplePickerService,
    RefreshCacheService,
    TextBlockService,
    UserGridConfigService,
    UserService,
    VersionService,
} from "./index";
import { ReportService } from "./ReportService";

/**
 * @hidden
 */
export class ServiceProvider {
    public static current: ServiceProvider;
    public static init() {
        this.current = new ServiceProvider();
    }

    public Base: BaseService;
    public Command: CommandService;
    public DropDown: DropDownService;
    public Environment: EnvironmentService;
    public Export: ExportService;
    public GlobalSearch: GlobalSearchService;
    public GridDefinition: GridDefinitionService;
    public Language: LanguageService;
    public Menu: MenuService;
    public Notification: NotificationService;
    public PageToken: PageTokenService;
    public PeoplePicker: PeoplePickerService;
    public RefreshCache: RefreshCacheService;
    public ReportService: ReportService;
    public TextBlock: TextBlockService;
    public UserGridConfig: UserGridConfigService;
    public User: UserService;
    public Version: VersionService;
    public DatabaseImage: DatabaseImageService;
    public FileDownload: FileDownloadService;

    constructor() {
        this.Base = new BaseService();
        this.Command = new CommandService();
        this.DropDown = new DropDownService();
        this.Environment = new EnvironmentService();
        this.Export = new ExportService();
        this.GlobalSearch = new GlobalSearchService();
        this.GridDefinition = new GridDefinitionService();
        this.Language = new LanguageService();
        this.Menu = new MenuService();
        this.Notification = new NotificationService();
        this.PageToken = new PageTokenService();
        this.PeoplePicker = new PeoplePickerService();
        this.RefreshCache = new RefreshCacheService();
        this.ReportService = new ReportService();
        this.TextBlock = new TextBlockService();
        this.UserGridConfig = new UserGridConfigService();
        this.User = new UserService(this.TextBlock);
        this.Version = new VersionService();
        this.DatabaseImage = new DatabaseImageService();
        this.FileDownload = new FileDownloadService();
    }
}
